import React, { useEffect } from 'react';
import { View } from 'react-native';
import useCountDown from './use-count-down';
const CountDown = (props) => {
    const { time, format, duration, onFinish, children } = props;
    const { current, pause, start, reset, resetOptions } = useCountDown({
        time,
        format,
        duration,
        onFinish() {
            onFinish && onFinish();
        },
    });
    useEffect(() => {
        reset(time);
    }, [time]);
    useEffect(() => {
        resetOptions({
            format: format,
            duration: duration,
        });
    }, [format, duration]);
    return React.createElement(View, null, children(current));
};
export { CountDown };
